import { lazy } from "react";

/** Loader view attività dipendenti */
export default function load(code) {
  switch (code) {
    case "employee-activities/list":
      return lazy(() => import("views/employee-activities/list"));
    default:
      return null;
  }
}
